<div class="container my-4">
    <div class="text-center mb-4">
        <button class="btn btn-primary mx-2"
            (click)="showDays = true; preview = false; previewEmployees = false; showPermissions = false;">Unesite slobodne dane za
            zaposlene</button>
        <button class="btn btn-secondary mx-2" (click)="preview = true; showDays = false; showEmployeeAbsenceData = false; showPermissions = false; getAllAbsenceData(); isLoading = true;">Pregled slobodnih
            dana</button>
        <button class="btn btn-info mx-2"
            (click)="showPermissions = true; preview = false; showDays = false; previewEmployees = false; showEmployeeAbsenceData = false; loadPermissionsData()">Permisije</button>
    </div>

    <app-loader *ngIf="isLoading"></app-loader>

    <div>
        <div class="form-group" *ngIf="showDays">
            <div>
                <label for="yearInput">Godina:</label>
                <input type="number" id="yearInput" class="form-control" [(ngModel)]="selectedYear">
            </div>
            <div class="btn-position">
                <button class="btn btn-primary ml-2" (click)="getHolidaysDaysAndHours()" [ngDisabled]='pending'>
                    <span *ngIf='!pending'>Prikaži</span>
                    <span *ngIf="pending">
                        <div class="loader"></div>
                    </span>
                </button>
            </div>
        </div>

        <div class="user-list scrollable-container margin-top-85" *ngIf="showEmployeeAbsenceData">
            <div *ngFor="let user of users; index as i" class="card mb-3">
                <div class="card-body">
                    <h3 class="card-title">{{user.first_name}} {{user.last_name}}</h3>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="days-{{i}}">Dani</label>
                                <input type="text" id="days-{{i}}" class="form-control" [(ngModel)]="user.days">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="hours-{{i}}">Sati</label>
                                <input type="text" id="hours-{{i}}" class="form-control" [(ngModel)]="user.hours">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn btn-success fixed-bottom-left" (click)="saveHolidaysDaysAndHours()">
                <span *ngIf='!pendingSave'>Sačuvaj</span>
                <span *ngIf='pendingSave'>
                    <div class="loader"></div>
                </span>
            </button>
        </div>
    </div>

    <div *ngIf="!isLoading">
        <div class="form-group" *ngIf="preview">
            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Godine:</mat-label>
                    <mat-select [formControl]="yearControl" multiple>
                      <mat-option *ngFor="let year of years" [value]="year">
                        {{ year }}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="btn-position">
                <button class="btn btn-warning ml-2" (click)="exportXLS()" [ngDisabled]='pendingExport'>
                    <span *ngIf='!pendingExport'>Eksport XLS</span>
                    <span *ngIf="pendingExport">
                        <div class="loader"></div>
                    </span>
                </button>
            </div>

            <div class="btn-position">
                <button class="btn btn-primary ml-2" (click)="getAbsences()" [ngDisabled]='pending'>
                    <span *ngIf='!pending'>Prikaži</span>
                    <span *ngIf="pending">
                        <div class="loader"></div>
                    </span>
                </button>
            </div>
        </div>

        <div class="user-list-2 scrollable-container margin-top-85" *ngIf="previewEmployees">
            <table class="table">
                <thead>
                    <tr>
                        <th>Ime i prezime</th>
                        <th>Godina</th>
                        <th>Ukupno slobodnih dana</th>
                        <th>Ukupno slobodnih sati</th>
                        <th>Ukupno slobodnih minuta</th>
                        <th>Ukupno iskorišćenih dana</th>
                        <th>Ukupno iskorišćenih sati</th>
                        <th>Ukupno iskorišćenih minuta</th>
                        <th>Ostalo slobodnih dana</th>
                        <th>Ostalo slobodnih sati</th>
                        <th>Ostalo slobodnih minuta</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of employeesAbsenceData; index as i">
                        <td>{{user.first_name}} {{user.last_name}}</td>
                        <td>{{user.year}}</td>
                        <td>{{user.days}}</td>
                        <td>{{user.hours}}</td>
                        <td>{{user.minutes}}</td>
                        <td>{{user.usedDays}}</td>
                        <td>{{user.usedHours}}</td>
                        <td>{{user.usedMinutes}}</td>
                        <td>{{user.remainingDays ? user.remainingDays : user.days}}</td>
                        <td>{{user.remainingHours ? user.remainingHours : user.hours}}</td>
                        <td>{{user.remainingMinutes ? user.remainingMinutes : user.minutes}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="permissionArray.includes(userId)">
        <div *ngIf="showPermissions">
            <div>
                <div class="mb-4 margin-top-85">
                    <h3>Dodajte permisije:</h3>
                </div>

                <div class="text-center mb-4 border-black" *ngIf="!pendingSaveUser">
                    <app-choose-assigned-users [ids]="assigned.value" [myForm]="form"
                        (outputToParent)="getAssignedIds($event)"></app-choose-assigned-users>
                </div>

                <div>
                    <button type="button" class="btn btn-success float-right" (click)="saveNewHolidayPermissions()" [ngDisabled]="pendingSaveUser">
                        <span *ngIf='!pendingSaveUser'>Sačuvaj</span>
                        <span *ngIf="pendingSaveUser">
                            <div class="loader"></div>
                        </span>
                    </button>
                </div>
            </div>

            <div class="margin-top-90" *ngIf="showPermittedUsers">
                <h3>Korisnici koji dijele Vaše permisije:</h3>
                <div class="row margin-top-20" *ngFor="let permission of allowedUserPermission">
                    <div class="col-md-2">
                        {{ permission.ime_prezime }}
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-sm btn btn-danger" (click)="deductUserPermission(permission)" [ngDisabled]="pendingDecution">
                            <i class="lni lni-cross-circle"></i>
                        </button>
                    </div>
                    <div class="col-md-8"></div>
                </div>
            </div>
        </div>

    </div>
</div>
